import { FILTER_VALUE_SEPARATOR } from '@aibees/elephant/constants/filters';

export function convertSearchParamToArray(value?: string) {
  return value?.split(FILTER_VALUE_SEPARATOR).filter((x) => !!x.length);
}

export function convertValueToArray(value?: string) {
  return convertSearchParamToArray(convertValueToSearchParam(value));
}

export function convertSearchParamToValue(value?: string) {
  return value ? value.replaceAll(FILTER_VALUE_SEPARATOR, '\n') : '';
}

export function convertValueToSearchParam(value?: string) {
  if (!value) return undefined;
  let ret = value
    .replace(/^(\n)*/, '')
    .replace(/\n*$/, '')
    .replaceAll('\n', FILTER_VALUE_SEPARATOR);
  if (ret?.endsWith(FILTER_VALUE_SEPARATOR))
    ret = ret.replace(`/${FILTER_VALUE_SEPARATOR}+$/`, '');
  return ret;
}

export function buildBulkInputSearchParamsDraft(
  values: Record<string, string[]>,
  fields: string[]
) {
  return fields.reduce((acc, x) => {
    return {
      ...acc,
      [x]: values[x]
        ? values[x].filter((y) => !!y.length).map((y) => y.trim())
        : undefined,
    };
  }, {});
}

export function hasDefaultValue(
  defaultValues: Record<string, string | undefined>
) {
  return Object.keys(defaultValues).some((k) => !!defaultValues[k]);
}
